export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "AccountingService",
  "name": "Bookkeeping Services South Africa",
  "description": "Professional bookkeeping, payroll, SARS compliance, and tax services for South African businesses",
  "url": "https://bookkeepingservices.co.za",
  "email": "info@bookkeepingservices.co.za",
  "telephone": "+27-000-000-0000",
  "priceRange": "R350 - R2500/month",
  "areaServed": {
    "@type": "Country",
    "name": "South Africa"
  },
  "serviceType": [
    "Bookkeeping",
    "Payroll Services",
    "Tax Returns",
    "SARS Compliance",
    "Annual Financial Statements",
    "CIPC Annual Returns",
    "VAT Registration",
    "Company Registration"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Bookkeeping Service Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "Starter Package",
        "price": "350",
        "priceCurrency": "ZAR",
        "description": "Basic bookkeeping for small businesses"
      },
      {
        "@type": "Offer",
        "name": "Growth Package",
        "price": "650",
        "priceCurrency": "ZAR",
        "description": "Growing businesses with payroll needs"
      },
      {
        "@type": "Offer",
        "name": "Professional Package",
        "price": "1500",
        "priceCurrency": "ZAR",
        "description": "Full-service for established businesses"
      }
    ]
  },
  "sameAs": []
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What accounting software do you work with?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We work with all major South African accounting platforms including Sage, Xero, QuickBooks, and Pastel. We'll use whichever system works best for your business."
      }
    },
    {
      "@type": "Question",
      "name": "How quickly can you start?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We can typically onboard new clients within 48 hours. Book a call and we'll have you set up by the end of the week."
      }
    },
    {
      "@type": "Question",
      "name": "Do you handle SARS audits?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide full support during SARS audits and can represent you in discussions with SARS when needed."
      }
    },
    {
      "@type": "Question",
      "name": "What if my books are behind?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No problem! We specialize in catching up backlogged books. We'll assess your situation and provide a clear plan to get you current."
      }
    }
  ]
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Bookkeeping Services South Africa",
  "description": "SAICA registered bookkeeping and accounting services",
  "url": "https://bookkeepingservices.co.za",
  "email": "info@bookkeepingservices.co.za",
  "priceRange": "R350 - R2500",
  "areaServed": "South Africa",
  "serviceArea": {
    "@type": "Country",
    "name": "South Africa"
  }
};

export const siteNavigationSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "SiteNavigationElement",
      "name": "Services",
      "description": "Bookkeeping, payroll, tax returns, SARS compliance and more",
      "url": "https://bookkeepingservices.co.za/services"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Packages & Pricing",
      "description": "Affordable bookkeeping packages from R350/month",
      "url": "https://bookkeepingservices.co.za/packages"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "About Us",
      "description": "SAICA registered bookkeeping professionals",
      "url": "https://bookkeepingservices.co.za/about"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Book a Call",
      "description": "Schedule a free consultation with our bookkeeping team",
      "url": "https://bookkeepingservices.co.za/book-a-call"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Contact",
      "description": "Get in touch with Bookkeeping Services South Africa",
      "url": "https://bookkeepingservices.co.za/contact"
    }
  ]
};
